module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2016/april-69fd2cf657179a21934561243c4518e3.png";